/**
 * Settlement Advance Routes.
 */
export const settlementAdvance = {
  depositInstructions: '/settlement-advance/deposit-instructions',
}
